export default __webpack_public_path__ + "static/media/sf-no-invoice.d150de7c.png";